import moment from "moment";
import _ from 'lodash';

export enum IntervalMode {
    ALL_TIME = 'all_time',
    TODAY = 'today',
    YESTERDAY = 'yesterday',
    WEEK = '-1 week',
    MONTH = '-1 month',
    YEAR = '-1 year',
}

export function IntervalEnumLabels(value: IntervalMode): string {
    switch (value) {
        case IntervalMode.ALL_TIME:
            return 'За всё время'
        case IntervalMode.TODAY:
            return 'Сегодня';
        case IntervalMode.YESTERDAY:
            return 'Вчера';
        case IntervalMode.WEEK:
            return 'Неделя';
        case IntervalMode.MONTH:
            return 'Месяц';
        case IntervalMode.YEAR:
            return 'Год';
    }
}

export class Interval {
    start: Date | null;
    end: Date | null;

    constructor(start: Date | null, end: Date | null) {
        this.start = start;
        this.end = end;
    }

    private static begin(date: Date): Date {
        const day = _.clone(date);
        day.setHours(0, 0, 0, 0);
        return day;
    }

    private static end(date: Date): Date {
        const day = _.clone(date);
        day.setHours(23, 59, 59, 59);
        return day;
    }

    static createByMode(mode: IntervalMode): Interval {
        const now = new Date();
        switch (mode) {
            case IntervalMode.TODAY:
                return new Interval(this.begin(now), this.end(now));
            case IntervalMode.YESTERDAY:
                let yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                return new Interval(this.begin(yesterday), this.end(yesterday));
            case IntervalMode.WEEK:
                const firstDayWeer = new Date();
                firstDayWeer.setDate(firstDayWeer.getDate() - 7);
                return new Interval(this.begin(firstDayWeer), this.end(now));
            case IntervalMode.MONTH:
                const firstDayMonth = new Date();
                firstDayMonth.setDate(firstDayMonth.getDate() - 30);
                return new Interval(this.begin(firstDayMonth), this.end(now));
            case IntervalMode.YEAR:
                const firstDayYear = new Date();
                firstDayYear.setDate(firstDayYear.getDate() - 365);
                return new Interval(this.begin(firstDayYear), this.end(now));
        }
    }

    toString(): string {
        if (this.start && this.end) {
            return `${moment(this.start).format('lll')} - ${moment(this.end).format('lll')}`
        }

        if (this.start) {
            return `от ${moment(this.start).format('lll')}`;
        }

        if (this.end) {
            return `до ${moment(this.end).format('lll')}`;
        }

        return '';
    }
}
